export default {"src":"/_next/static/media/register-background.8ca483ba.svg","height":1080,"width":720,"blurWidth":0,"blurHeight":0};